export default __webpack_public_path__ + "static/media/lefteye.40d38fdf.svg";